import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { RolesTable } from "../../UI/Roles/RolesTable";

const RolesPanel = () => {
  return (
    <div>
      <PanelHead title="Employees" />
      <PanelBody content={<RolesTable />} />
    </div>
  );
};

export default React.memo(RolesPanel);
